import { ColumnLayout, FormField, Input, SpaceBetween } from '@amzn/awsui-components-console';
import type { CodePackageState, FieldErrors } from './evaluationSubjects';

interface Props {
  value: CodePackageState;
  onChange: (patch: Partial<CodePackageState>) => void;
  errors: FieldErrors;
}

export function CodePackageFields({ value, onChange, errors }: Props) {
  return (
    <SpaceBetween size="l">
      <ColumnLayout columns={2}>
        <FormField
          label="Package name"
          description="The Brazil package to evaluate, exactly as it appears at code.amazon.com/packages."
          constraintText="Required"
          errorText={errors.packageName}
        >
          <Input
            value={value.packageName}
            onChange={({ detail }) => onChange({ packageName: detail.value })}
            placeholder="MyServicePackage"
          />
        </FormField>
        <FormField
          label="Commit ID"
          description="The commit to evaluate the package at. Leave blank to scan the current tip of the branch. Copy the full SHA from git log or the commit page — an abbreviated one is rejected."
          constraintText="Optional. A full 40-character hex SHA."
        >
          <Input
            value={value.commitId}
            onChange={({ detail }) => onChange({ commitId: detail.value })}
            placeholder="e3b0c44298fc1c149afbf4c8996fb92427ae41e4"
          />
        </FormField>
      </ColumnLayout>
      <ColumnLayout columns={2}>
        <FormField
          label="Branch name"
          description="The branch the commit is on, or whose tip is scanned when no commit is given. Defaults to mainline."
          constraintText="Optional"
        >
          <Input
            value={value.branchName}
            onChange={({ detail }) => onChange({ branchName: detail.value })}
            placeholder="mainline"
          />
        </FormField>
        <FormField
          label="Version set"
          description="The Brazil version set the package builds in."
          constraintText="Optional"
        >
          <Input
            value={value.versionSet}
            onChange={({ detail }) => onChange({ versionSet: detail.value })}
            placeholder="MyVersionSet/mainline"
          />
        </FormField>
      </ColumnLayout>
    </SpaceBetween>
  );
}
